/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryfilteredempty3Inputs */

const en_medialibraryfilteredempty3 = /** @type {(inputs: Medialibraryfilteredempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You haven't created anything with this tool yet.`)
};

const de_medialibraryfilteredempty3 = /** @type {(inputs: Medialibraryfilteredempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit diesem Werkzeug hast du noch nichts erstellt.`)
};

/**
* | output |
* | --- |
* | "You haven't created anything with this tool yet." |
*
* @param {Medialibraryfilteredempty3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryfilteredempty3 = /** @type {((inputs?: Medialibraryfilteredempty3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryfilteredempty3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryfilteredempty3(inputs)
	return de_medialibraryfilteredempty3(inputs)
});
export { medialibraryfilteredempty3 as "mediaLibraryFilteredEmpty" }